const reducer = (
  state = {
    resetOTPSent: false,
    otpSent: false,
    passwordReset: false,
  },
  action,
) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        login: action.data,
      };
    case 'SIGNUP_SUCCESS':
      return {
        ...state,
        signup: action.data,
      };
    // case 'OTP_SENT':
    //   return {
    //     ...state,
    //     otpSent: true,
    //   };
    case 'RESET_RECAPTCHA':
      return {
        ...state,
        otpSent: false,
        resetOTPSent: false,
        passwordReset: false,
      };
    case 'RESET_OTP_SENT':
      return {
        ...state,
        resetOTPSent: true,
      };
    case 'MOBILE_NO_CHANGE_RESET_OTP_SENT':
      return {
        ...state,
        mncResetOTPSent: action.data,
      };
    case 'RESET_PASSWORD_SUCCESS':
      return {
        ...state,
        passwordReset: true,
      };
    case 'RESET_MOBILENO_SUCCESS':
      return {
        ...state,
        mobileNoReset: action.data,
      };
    case 'NAME_EDIT_SUCCESS':
      return {
        ...state,
        nameEditSuccess: action.data,
      };
    case 'INVITE_STATUS_CHECKED':
      return {
        ...state,
        invite: action.data,
      };
    case 'SET_LOGIN_DATA':
      return {
        ...state,
        userLoginData: action.data,
      };
    case 'CLEARALL': {
      return {};
    }
    default: {
      return state;
    }
  }
};

export default reducer;
